import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';

const advantages = [
  {
    icon: 'ri-cpu-line',
    title: '技术驱动 · 工业化量产',
    description:
      '自研AI工业化SOP生产标准平台，覆盖剧本创作、分镜设计、AI绘画、仿真人制作、剪辑配音全流程，月产千集级量产能力，已推出100部精品AI漫剧。',
    end: 100,
    suffix: '+',
    highlightLabel: '精品AI漫剧',
  },
  {
    icon: 'ri-landscape-line',
    title: '文化扎根 · 全域资产底座',
    description:
      '深耕山西117个县域，系统化采集历史传说、非遗技艺、古建文物、文旅地标、民俗风情等文化资源，建成全域文化数字资产库1.0。',
    end: 117,
    suffix: '',
    highlightLabel: '县域文化资产库',
  },
  {
    icon: 'ri-recycle-line',
    title: '模式闭环 · 可持续变现',
    description:
      '打通"资产采集—内容生产—IP孵化—品牌赋能—电商变现"全链路，实现文化资源的一次采集、多元创作、持续复利、全渠道商业变现。',
    end: 5,
    suffix: '',
    highlightLabel: '全链路商业闭环',
    isFullLink: true,
  },
  {
    icon: 'ri-team-line',
    title: '联盟协同 · 生态化赋能',
    description:
      '依托冯全普·县域AI+OPC联盟五大服务中台（市场、技术、培训、企服、品控），实现“一地需求、全网协同；一个项目、多方交付”的产业协作。',
    end: 5,
    suffix: '',
    highlightLabel: '五大服务中台支撑',
  },
];

export default function CoreAdvantages() {
  return (
    <section className="relative w-full bg-background-900 py-20 md:py-28 overflow-hidden">
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-accent-500/[0.02] rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute top-20 right-10 w-60 h-60 bg-primary-500/[0.015] rounded-full blur-3xl pointer-events-none"></div>

      <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
        <div className="max-w-screen-2xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-6">
                <span className="w-1 h-1 rounded-full bg-secondary-500"></span>
                <span className="text-secondary-300 text-xs font-medium tracking-wider whitespace-nowrap">
                  核心竞争力
                </span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 mb-4">
                技术驱动 · 文化扎根 · 模式闭环 · 联盟协同
              </h2>
              <p className="text-secondary-400 text-base max-w-2xl mx-auto">
                四大核心支柱，构建文化数字化全链路竞争壁垒
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {advantages.map((item) => (
              <ScrollReveal key={item.title}>
                <div className="advantage-card group relative bg-background-800/50 rounded-2xl border border-primary-500/10 p-8 md:p-10 transition-all duration-500">
                  {/* Glow effect on hover */}
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary-500/0 via-accent-500/0 to-primary-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                    style={{
                      backgroundImage: 'radial-gradient(circle at 30% 20%, rgba(200,160,80,0.06) 0%, transparent 60%), radial-gradient(circle at 70% 80%, rgba(180,100,60,0.04) 0%, transparent 60%)',
                    }}
                  ></div>

                  {/* Top corner glow */}
                  <div className="absolute top-0 right-0 w-32 h-32 bg-primary-500/[0.02] rounded-full blur-2xl group-hover:bg-primary-500/[0.06] transition-all duration-500 pointer-events-none"></div>

                  <div className="relative z-10">
                    <div className="w-14 h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mb-6 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-300">
                      <i className={`${item.icon} text-primary-500 text-2xl`}></i>
                    </div>

                    <h3 className="font-heading text-xl font-semibold text-foreground-50 mb-3 group-hover:text-primary-500 transition-colors duration-300">
                      {item.title}
                    </h3>
                    <p className="text-secondary-400 text-sm leading-relaxed mb-6">
                      {item.description}
                    </p>

                    <div className="pt-5 border-t border-primary-500/10 group-hover:border-primary-500/20 transition-colors duration-300">
                      {item.isFullLink ? (
                        <div className="font-heading text-xl font-bold text-primary-500">
                          全链路
                        </div>
                      ) : (
                        <div className="font-heading text-3xl font-bold text-primary-500">
                          <CountUp end={item.end} duration={2000} />
                          {item.suffix}
                        </div>
                      )}
                      <p className="text-secondary-500 text-xs mt-1">{item.highlightLabel}</p>
                    </div>
                  </div>

                  {/* Bottom border glow on hover */}
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-[1px] bg-gradient-to-r from-transparent via-primary-500/50 to-transparent group-hover:w-3/4 transition-all duration-500 rounded-full"></div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
